import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { useSelector } from 'store/hooks';
import FinancialMetricsTable from 'components/DashboardComponents/DashboardListTable/FinancialMetricsTable';
import LineBarChart from 'components/DashboardComponents/DashboardGraphs/LineBarChart';
import { GridSortModel } from '@mui/x-data-grid-pro';
import FinancialStatusBarChart from 'components/DashboardComponents/DashboardGraphs/FinancialStatusBarChart';
import StatusMatrixFinacialKpi from 'components/DashboardComponents/DashboardListTable/StatusMatrixFinacialKpi';

const KpiMetricsFinancialKPI = ({
  currencies,
  selectedCurrency,
  barChartData,
  metric,
  data_table,
  onDownloadXlsx,
  showDownload,
}) => {
  const { loadings } = useSelector((state) => state);

  const matchedCurrency = currencies?.find((c: any) => c.name.toLowerCase() === selectedCurrency?.toLowerCase());
  const symbol = matchedCurrency?.symbol === 'E' || !matchedCurrency?.symbol ? '€' : matchedCurrency?.symbol;

  return (
    <>
      <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
        {[{ title: 'Financial KPI', data: [], colors: [] }].map((item) => (
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={6}>
                <Paper
                  sx={{
                    height: { xs: '340px', sm: '450px', md: '360px', lg: '360px' },
                    flexGrow: 1,
                    flexBasis: 0,
                    borderRadius: 2,
                    p: { xs: 1.5, sm: 2, md: 2 },
                    boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <LineBarChart forecast_data={barChartData?.cumulative_income} symbol={symbol} />
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <Paper
                  sx={{
                    height: { xs: '340px', sm: '450px', md: '360px', lg: '360px' },
                    flexGrow: 1,
                    flexBasis: 0,
                    borderRadius: 2,
                    p: { xs: 1.5, sm: 2, md: 2 },
                    boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <FinancialMetricsTable completionList={barChartData?.income_status} symbol={symbol} />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>

      {/* Pending at Bar Chart */}
      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
              borderRadius: 2,
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
            }}
          >
            <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 600, mb: 1 }}>
              Status
            </Typography>
            <FinancialStatusBarChart data={barChartData} symbol={symbol} />
          </Paper>
        </Grid>
      </Grid>

      {/* Table Row */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <StatusMatrixFinacialKpi data={data_table?.financial_table} symbol={symbol} />
        </Grid>
      </Grid>
    </>
  );
};

export default KpiMetricsFinancialKPI;
